import React from 'react';

import { LucideIcon } from 'shared/components/ihcl/lucideIcon';
import { styled } from 'shared/components/ihcl/styled';
import { Button } from 'shared/components/ihcl/v2/button';

const StickySubmitFooterWrapper = styled('div', ({ $theme }) => ({
  position: 'fixed',
  bottom: '0',
  boxShadow: 'rgb(255, 255, 255) 0px -10px 20px 0px',
  paddingBottom: '34px',
  backgroundColor: $theme.colors.white,
  left: '50%',
  transform: 'translateX(-50%)',
  width: '100%',
  maxWidth: '560px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  paddingLeft: '16px',
  paddingRight: '16px',
  '@media screen and (max-width: 340px)': {
    paddingLeft: 0,
    paddingRight: 0,
  },
}));

type StickySubmitFooterProps = {
  disabled?: boolean;
  onClick?: () => void;
  form?: string;
  isLoading?: boolean;
  style?: React.CSSProperties;
};

const StickySubmitFooter = ({
  disabled = false,
  onClick = null,
  form = null,
  isLoading = false,
}: StickySubmitFooterProps) => (
  <StickySubmitFooterWrapper>
    <Button
      fullWidth
      color="alternate"
      disabled={disabled}
      type={form ? 'submit' : 'button'}
      {...(onClick ? { onClick } : {})}
      {...(form ? { form } : {})}
      loading={isLoading}
    >
      Next
      <LucideIcon name="ArrowRight" />
    </Button>
  </StickySubmitFooterWrapper>
);

export default StickySubmitFooter;
